// extracted by mini-css-extract-plugin
export default {"coolGradient":"Accounts_coolGradient__YUffc","primaryButton":"Accounts_primaryButton__AW4eK","organizationLogo":"Accounts_organizationLogo__DlKip"};